import {NgModule} from '@angular/core';
import {SharedModule} from '../../app-common/shared.module';
import {guideRoutingComponents, GuideRoutingModule} from './guide-routing.module';
import {BoxedLinkComponent} from './components/boxed-link/boxed-link.component';
import {GuideTaxonomyBoxComponent} from './components/guide-taxonomy-box/guide-taxonomy-box.component';
import {GuideUrlResolverService} from './services/guide-url-resolver.service';
import {GuidePostUrlResolverService} from './services/guide-post-url-resolver.service';
import {AdcampaignService} from '../../services/adcampaign.service';
import {SharedCmsModule} from '../../app-common/shared-cms.module';
import {UiButtonComponent} from '../../components/ui/ui-button/ui-button.component';

@NgModule({
  declarations: [guideRoutingComponents, BoxedLinkComponent, GuideTaxonomyBoxComponent],
  imports: [
    SharedModule,
    GuideRoutingModule,
    SharedCmsModule,
    // SearchWidgetV2Module,
    UiButtonComponent,
  ],
  providers: [GuideUrlResolverService, GuidePostUrlResolverService, AdcampaignService],
  exports: [],
})
export class GuideModule {}
